(function (window, document) {
  'use strict';
  var PICKUP_MAX_DAYS = 7;

  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var h = escapeHtml;

  function toIsoDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  function openPickupDateModal(opts) {
    opts = opts || {};
    var currentDate = opts.currentDate || '';
    var rawSlot = opts.currentSlot || '';
    var selectedSlot = rawSlot === 'matin' || rawSlot === 'apremidi' ? rawSlot : '';
    var today = new Date();
    var tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    var maxDate = new Date(today);
    maxDate.setDate(today.getDate() + PICKUP_MAX_DAYS);
    var minIso = toIsoDate(tomorrow);
    var maxIso = toIsoDate(maxDate);

    var intro = t('modal_pickup_date_intro').replace('{{ max_days }}', String(PICKUP_MAX_DAYS));
    var slotMorningActive = selectedSlot === 'matin';
    var slotAfternoonActive = selectedSlot === 'apremidi';

    var content =
      '<div class="bp-modal__container bp-modal-pickup">' +
      '<button type="button" class="bp-modal__close" data-bp-modal-close aria-label="' +
      h(t('modal_close_aria')) +
      '">&times;</button>' +
      '<h2 class="bp-modal__title">' +
      h(t('modal_pickup_date_title')) +
      '</h2>' +
      '<p class="bp-modal__intro">' +
      h(intro) +
      '</p>' +
      '<label class="bp-modal-pickup__label" for="bp-pickup-date-input">' +
      h(t('modal_pickup_date_field_label')) +
      '</label>' +
      '<input id="bp-pickup-date-input" type="date" class="bp-modal-pickup__input" data-bp-pickup-input min="' +
      h(minIso) +
      '" max="' +
      h(maxIso) +
      '" value="' +
      h(currentDate) +
      '" required>' +
      '<fieldset class="bp-modal-pickup__slot">' +
      '<legend class="bp-modal-pickup__slot-legend">' +
      h(t('modal_pickup_date_slot_label')) +
      '</legend>' +
      '<div class="bp-modal-pickup__slot-options">' +
      '<button type="button" class="bp-modal-pickup__slot-btn' +
      (slotMorningActive ? ' is-active' : '') +
      '" data-bp-pickup-slot="matin" aria-pressed="' +
      (slotMorningActive ? 'true' : 'false') +
      '">' +
      h(t('pickup_slot_morning')) +
      '</button>' +
      '<button type="button" class="bp-modal-pickup__slot-btn' +
      (slotAfternoonActive ? ' is-active' : '') +
      '" data-bp-pickup-slot="apremidi" aria-pressed="' +
      (slotAfternoonActive ? 'true' : 'false') +
      '">' +
      h(t('pickup_slot_afternoon')) +
      '</button>' +
      '</div>' +
      '</fieldset>' +
      '<p class="bp-modal-pickup__error" data-bp-pickup-error hidden></p>' +
      '<div class="bp-modal__actions">' +
      '<button type="button" class="bp-link-button" data-bp-modal-close>' +
      h(t('modal_pickup_date_cancel')) +
      '</button>' +
      '<button type="button" class="bp-cta-pastel" data-bp-pickup-submit disabled>' +
      h(t('modal_pickup_date_submit')) +
      '</button>' +
      '</div>' +
      '</div>';

    var modals = window.buybackPortalModals || {};
    var createDialog = modals._createDialog;
    var bindClose = modals._bindClose;
    var closeCurrent = modals._closeCurrent;
    if (typeof createDialog !== 'function') {
      try {
        console.warn('[bp:pickup-date] buybackPortalModals._createDialog manquant');
      } catch (e) {}
      return null;
    }

    return createDialog({
      className: 'bp-modal--pickup',
      content: content,
      ariaLabel: t('modal_pickup_date_title'),
      onMount: function (dlg) {
        if (typeof bindClose === 'function') bindClose(dlg, '[data-bp-modal-close]');
        var input = dlg.querySelector('[data-bp-pickup-input]');
        var submitBtn = dlg.querySelector('[data-bp-pickup-submit]');
        var errEl = dlg.querySelector('[data-bp-pickup-error]');
        var slotBtns = dlg.querySelectorAll('[data-bp-pickup-slot]');
        // Comparaison lexicographique sûre sur ISO YYYY-MM-DD (ordre alpha = ordre chrono).
        var refreshSubmit = function () {
          submitBtn.disabled = !input.value || input.value < minIso || input.value > maxIso || !selectedSlot;
        };
        input.addEventListener('input', refreshSubmit);
        input.addEventListener('change', refreshSubmit);
        for (var i = 0; i < slotBtns.length; i++) {
          slotBtns[i].addEventListener('click', function (e) {
            var btn = e.currentTarget;
            selectedSlot = btn.getAttribute('data-bp-pickup-slot');
            for (var j = 0; j < slotBtns.length; j++) {
              var other = slotBtns[j];
              if (other === btn) {
                other.classList.add('is-active');
                other.setAttribute('aria-pressed', 'true');
              } else {
                other.classList.remove('is-active');
                other.setAttribute('aria-pressed', 'false');
              }
            }
            refreshSubmit();
          });
        }
        refreshSubmit();
        // Focus initial sur l'input pour utilisateurs clavier/lecteur d'écran.
        setTimeout(function () {
          try {
            input.focus();
          } catch (e) {}
        }, 0);
        submitBtn.addEventListener('click', function () {
          if (submitBtn.disabled) return;
          errEl.hidden = true;
          errEl.textContent = '';
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
          var originalLabel = submitBtn.textContent;
          submitBtn.textContent = t('modal_pickup_date_loading_cta');
          if (typeof opts.onConfirm === 'function') {
            opts.onConfirm(input.value, selectedSlot, {
              showError: function (msg) {
                errEl.textContent = msg;
                errEl.hidden = false;
                submitBtn.disabled = false;
                submitBtn.removeAttribute('aria-busy');
                submitBtn.textContent = originalLabel;
              },
              close: function () {
                if (typeof closeCurrent === 'function') closeCurrent();
              },
            });
          }
        });
      },
    });
  }

  window.buybackPortalModalPickupDate = { open: openPickupDateModal };
})(window, document);
